<template>
  <b-dropdown variant="link"
              v-if="rights.includes('crm')"
              right
              class="ml-2 font-size-0">
    <template #button-content>
      <a v-b-tooltip.hover
         class="pointer position-relative"
         style="top: -1px;"
         :title="$t('add_to_funnel')">
        <FilterSvg class="svg-primary svg-size-lg"/>
      </a>
    </template>
    <b-dropdown-item
        @click="addToLeads">
      {{ $t('applications_and_appeals') }}
    </b-dropdown-item>
    <b-dropdown-item
        @click="addToPatientCanban">
      {{ $t('funnel_came_and_repeated') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script setup>
import FilterSvg from "@/assets/svg-vue/sidebar/crm.svg.vue"
import { computed, getCurrentInstance, onBeforeMount } from "vue"
import { useStore } from "vuex"
import { CRMService } from "@/services/api/crm.api.service"
import {useRouter} from "vue-router"

const { patient } = defineProps({
  patient: {
    type: Object,
    required: true
  }
})

let i18n = null
let noty = null

const store = useStore()
const router = useRouter()

const canbanMode = computed(() => store.getters.dynamicConfigValue('canban_mode') || 'manual')
const rights = computed(() => store.state.auth.rights)

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const addToLeads = async () => {
  await createCanbanFromPatient('lead')
}

const addToPatientCanban = async () => {
  const res = await createCanbanFromPatient('patient_canban')
  if(canbanMode.value === 'auto' && res.id) {
    await router.push({ name: 'CRMFunnelPatientPage', params: { canbanId: res.id } })
  }
}

const createCanbanFromPatient = async (type) => {
  try {
    const res = await CRMService.createCanbanFromPatient({
      patient_id: patient.id,
      type
    })
    if(res?.data) {
      noty.info(i18n.t('success_message'))
      return res.data
    }
  } catch (e) {
    console.log(e)
  }
  return null
}
</script>
